import { OfficeIcon } from "components/icons/v2/Office";
import { ReactNode } from "react";

export const buildConfirmEntitySummary = (
  companyName: string,
  entityName: string,
  extra?: string
): ReactNode => {
  const parts = [companyName, entityName, extra].filter(Boolean);
  return (
    <div className="t-flex t-items-center t-gap-2 t-text-body-sm t-text-text-60">
      <span className="t-flex t-shrink-0 t-rounded t-bg-surface-purple t-p-1 t-text-purple-70">
        <OfficeIcon />
      </span>
      <span>{parts.join(" · ")}</span>
    </div>
  );
};
